// extracted by mini-css-extract-plugin
export var borderRadius = "_gs-4";
export var large = "_gs-3";
export var logoContainer = "_gs-0";
export var nameLogo = "_gs-2";
export var small = "_gs-1";